<button 
  (click)="onExport()" 
  class="excelBtn"
  [pTooltip]="exportTooltip"
  tooltipPosition="bottom">
</button>